import i18n from '/common/plugins/vue-i18n.js' 

let lang = window.localStorage.getItem('language');
if(!lang)	
{
    lang = "zh_TW"				
}
i18n.locale = lang

const permissionTypeList =  [
    { key: "UPGPT", name: "UpGPT"},
];

export default permissionTypeList;

